import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CardTitle, Row, Col, UncontrolledCollapse } from "reactstrap";
import questionCoin from "assets/image/questions-coin.png";

const CoinQuestions = ({ questionsArray }: any) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col xs="12" md="12" lg="8" xl="8">
        <CardTitle>
          <h2>
            <span className="fs-5 fw-bold text-secondary-two-light pt-3 title-bordre-bottom">
              {t("Frequently Asked Questions")}
            </span>
          </h2>
          <br />
        </CardTitle>
        <div className="list collapse-list">
          <ul>
            {questionsArray.map((item: any, index: number) => (
              <li>
                {item.id ? (
                  <>
                    <div
                      id={item.id}
                      className=" d-flex justify-content-between align-items-center "
                    >
                      <span className="fs-7 lh-md-sm">{t(item.question)}</span>
                      <i className="icon-circle-down" />
                    </div>
                    <UncontrolledCollapse
                      toggler={item.id}
                      defaultOpen={item.id == "toggler1"}
                    >
                      <p className="fs-6 py-3 text-secondary-two-light">
                        {t(item.answer)}
                      </p>
                    </UncontrolledCollapse>
                  </>
                ) : (
                  <> </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Col>
      <Col xs="4" className="d-none d-lg-block d-xl-block align-self-center">
        <img src={questionCoin} className="w-100" />
      </Col>
    </Row>
  );
};
export default CoinQuestions;
